import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
/* import Dashboard from "./components/Dashboard";
 */ import "./App.css"; // Ensure this includes your flex layout sty
import Main from "./components/Main";
/* import Table from "./components/Aduit/Table"; */
import Profile from "./components/Profile";
import Login from "./components/Login";
import AuthProvider from "./context/AuthProvider";
import Page404 from "./components/Page404";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "react-hot-toast";
import Dashboard from "./Pages/Dashboard";
import Leads from "./Pages/Leads";
import Enquiry from "./Pages/Enquiry";
import AddEnquiry from "./components/AddEnquiry";
import Franchise from "./Pages/Franchise";
import Config from "./Pages/Config";
import Account from "./components/Account";
import Interior from "./components/Interior";
import Breading from "./components/Breanding";
import PurchaseTeam from "./components/PurchaseTeam";
import DocumentTerm from "./components/DocumentTeam";
import InagrationDate from "./components/Inagaration";

import InterioTable from "./components/Team";
import BreadingTable from "./components/BreadingTable";
import PaymentModeTable from "./components/PaymentModeTable";
import DocumentTable from "./components/DocumentTabe";
import Employee from "./Pages/Employee";
import AddEmployee from "./components/AddEmployee";
import FranchiseDetails from "./Pages/FranchiseDetails";
import Works from "./Pages/Work";
import WorkForm from "./Pages/WorkForm";
import Teams from "./Pages/Teams";

function App() {
  useEffect(() => {
    const images = document.querySelectorAll("img");
    images.forEach((img) => {
      img.setAttribute("loading", "lazy");
    });
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Page404 />} />
          <Route
            element={
              <ProtectedRoute allowedRoles={["super-admin", "employee"]} />
            }
          >
            <Route path="/" element={<Main />}>
              <Route path="dashboard" index element={<Dashboard />} />
              <Route path="works" element={<Works />} />
              <Route path="work/:fId/:tId" element={<WorkForm />} />
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["super-admin"]} />}>
            <Route path="/" element={<Main />}>
              <Route path="enquiry" element={<Enquiry />} />
              <Route path="addenquiry" element={<AddEnquiry />} />

              <Route path="leads" element={<Leads />} />

              <Route path="franchise" element={<Franchise />} />
              <Route path="franchise/:id" element={<FranchiseDetails />} />

              <Route path="account" element={<Account />} />

              <Route path="employee" element={<Employee />} />
              <Route path="addEmployee" element={<AddEmployee />} />
              <Route path="teams" element={<Teams />} />


              <Route path="config" element={<Config />} />
            </Route>
          </Route>

          {/* Add other routes here */}
        </Routes>
        {/* </main>
        </div>
      </div> */}
        <Toaster
          position="top-right"
          containerStyle={{
            top: 10,
          }}
          toastOptions={{
            className: "",
            style: {
              background: "#575555",
              color: "white",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top whenever the route changes
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};
